import { googlelogin } from "./Auth/Auth.saga";
import { prenotazioneSaga } from "./Prenotazione/Prenotazione.saga";

export function* rootSaga(){
    yield* googlelogin();
    yield* prenotazioneSaga();
}